// Coerce a value to a finite number. Defaults to 0 for anything the
// API hasn't populated yet (or that arrived in the wrong case during a
// shape mismatch) so a single missing field never bricks a whole page.
export function safeNumber(value: unknown, fallback = 0): number {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  return fallback;
}

export function formatCount(value: unknown): string {
  return safeNumber(value).toLocaleString();
}

export function formatBytes(value: unknown): string {
  const n = safeNumber(value);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1024 / 1024).toFixed(1)} MB`;
  return `${(n / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

export function formatCents(value: unknown): string {
  return `$${(safeNumber(value) / 100).toFixed(2)}`;
}

const TIER_LABELS: Record<string, string> = {
  free: "Free",
  standard: "Standard",
  managed_isolated: "Managed Isolated"
};

export function formatTier(tier: string): string {
  return TIER_LABELS[tier] ?? tier;
}

const TIER_TAGLINES: Record<string, string> = {
  free: "1,000 signatures / month, no card on file.",
  standard: "$5 / month — 5,000 witnesses + 1 GB included, then $0.001 each.",
  managed_isolated: "Dedicated infrastructure with included signatures."
};

export function tierTagline(tier: string): string {
  return TIER_TAGLINES[tier] ?? "";
}
